import React, { useCallback, useRef, useState, useEffect } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import {
  Button,
  Col,
  DatePicker,
  Row,
  Table,
  Tabs,
  Select,
  Badge,
  Drawer,
  Space,
  Popconfirm,
} from 'antd'
import { get } from 'lodash-es'
import config from './config'
import styles from '../../index.module.less'
import { useSetState } from 'ahooks'
import { compensationSigningPage, ticketsListAccept, ticketsBack } from '@/services/homeService'
import { log } from 'console'
import { getUser } from '@/common/utils'
import { navigatePage } from '@/common/utils'
import { useNavigate } from 'react-router-dom'
import Detail from './detail'
import BackPage from './backPage'

const taskList = (props: any) => {
  const listRef = useRef<any>()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [state, setState] = useSetState({
    params: {},
    pageSize: 5,
    page: 1,
    hasNext: true,
    loading: false,
    minTaskId: '',
    maxTaskId: '',
  })
  const stateRef = useRef<any>(state)
  const [isVisible, setIsVisible] = useState(false)
  const [param, setParam] = useState<object>({})

  const [flag, setFlag] = useState<boolean>(false)

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { query } = values

        const current = stateRef.current.page
        const pageSize = stateRef.current.pageSize
        query.searchCountFlag = false
        query.stateCode = 'unfinished'
        query.minTaskId = current === 1 ? '' : stateRef.current.minTaskId
        query.maxTaskId = current === 1 ? '' : stateRef.current.maxTaskId
        query.typeCode = 'crmTickets'
        query.stateCode = 'unfinished'
        compensationSigningPage(current, pageSize, query).then((resp: any) => {
          stateRef.current.minTaskId =
            resp.records.length > 0 ? resp.records[resp.records.length - 1].id : ''
          stateRef.current.maxTaskId = resp.records.length > 0 ? resp.records[0].id : ''
          stateRef.current.hasNext = resp.records.length >= stateRef.current.pageSize
          if (current === 1 && !resp.records.length > 0) {
            setFlag(true)
          }
          setState({
            hasNext: stateRef.current.hasNext,
            loading: false,
          })
          resolve(resp)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const onPageSizeChange = (value: any) => {
    stateRef.current.minTaskId = ''
    stateRef.current.maxTaskId = ''
    stateRef.current.pageSize = value
    setState({ pageSize: value })
    listRef.current && listRef.current.reload()
  }

  const onPrev = () => {
    const prev = state.page - 1
    if (prev > 0) {
      stateRef.current.page = prev
      stateRef.current.minTaskId = ''
      setState({ page: prev })
      listRef.current && listRef.current.reload()
    }
  }

  const onNext = () => {
    if (state.hasNext) {
      stateRef.current.page = state.page + 1
      stateRef.current.maxTaskId = ''
      setState({ page: state.page + 1 })
      listRef.current && listRef.current.reload()
    }
  }

  const onJump = (record: any) => {
    const userInfo = getUser()
    const pushState = { name: '流程详情' } // 产品要求流程详情标题固定：流程详情
    const url = `workflow${record.param}/${record.flowTaskId}`
    let appNames = ''

    let newUrl = url
    // let newSearch = search
    let index = url?.indexOf('?')
    let result = ''
    if (index > -1) {
      result = url?.substring(index)
      newUrl = url?.slice(0, index)
    }
    let newSearch = result
    let list = newUrl?.split('/').filter(Boolean)
    if (list.length > 0) {
      appNames = list[0]
      list.shift()
      newUrl = list.join('/')
    }
    navigatePage(appNames, '/' + newUrl, navigate, '', newSearch)
    // navigatePage(`workflow${record.param}/${record.flowTaskId}`,pushState)
  }

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const extension = {
    request: { fetchList },
    events: {},
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              onClick={() => {
                let param = JSON.parse(record.param)
                setParam(param)
                setOpen(true)
              }}
            >
              详情
            </SActionBtn>
            <SActionBtn
              onClick={() => {
                let param = JSON.parse(record.param)
                ticketsListAccept(param.id).then(res => {
                  stateRef.current.minTaskId = ''
                  stateRef.current.maxTaskId = ''
                  reloadFn()
                })
              }}
              title="确定要受理?"
              confirm
            >
              受理
            </SActionBtn>
            <SActionBtn
              onClick={() => {
                let param = JSON.parse(record.param)
                setParam(param)
                setIsVisible(true)
              }}
              title="确定要退回?"
            >
              退回
            </SActionBtn>
          </STableActions>
        )
      },
      stateCodeFn(text: any, record: any) {
        return (
          <span>
            <Badge status="processing" />
            <span style={{ marginLeft: '7px' }}>{text == 'unfinished' ? '待受理' : '已完成'}</span>
          </span>
        )
      },
    },
  }

  const closeDrawer = () => {
    setOpen(false)
  }

  return (
    <div style={{ backgroundColor: '#fff', height: '420px', marginBottom: '10px' }}>
      <div className={styles.deliveryOperation}>
        <div className={styles.titleCon}>
          <div className={styles.titleText}>我的待办</div>
        </div>
        {!flag ? (
          <div>
            <div className={styles.taskContent}>
              <SLowcodeList config={config} ref={listRef} {...extension} />
            </div>
            <div className={styles.customPagination}>
              <Row gutter={10} justify="end">
                <Col>
                  <Button
                    // icon={<LeftOutlined />}
                    disabled={state.page <= 1 || state.loading}
                    onClick={onPrev}
                  >
                    上一页
                  </Button>
                </Col>
                <Col>
                  <Button
                    // icon={<RightOutlined />}
                    disabled={!state.hasNext || state.loading}
                    onClick={onNext}
                  >
                    下一页
                  </Button>
                </Col>
                <Col>
                  <Select
                    value={state.pageSize}
                    onChange={onPageSizeChange}
                    disabled={state.loading}
                  >
                    {[
                      { label: '5 条/页', value: 5 },
                      { label: '10 条/页', value: 10 },
                      { label: '20 条/页', value: 20 },
                    ].map((d: any, i) => (
                      <Select.Option key={`page_${i}`} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div className={styles.noData}>
            <img src={require('@/assets/taskListNoData.png')} />
            <div className={styles.noDataText}>暂无数据</div>
          </div>
        )}
      </div>

      <Drawer
        width={900}
        onClose={closeDrawer}
        open={open}
        closable={false}
        footer={
          <Space>
            <Button onClick={closeDrawer}>取消</Button>

            <Popconfirm
              title={'确定要受理?'}
              onConfirm={() => {
                ticketsListAccept(param.id).then(res => {
                  stateRef.current.minTaskId = ''
                  stateRef.current.maxTaskId = ''
                  reloadFn()
                  closeDrawer()
                })
              }}
            >
              <Button type="primary">受理</Button>
            </Popconfirm>

            <Button
              type="primary"
              onClick={() => {
                setIsVisible(true)
              }}
            >
              退回
            </Button>
          </Space>
        }
      >
        <Detail param={param} />
      </Drawer>

      {isVisible ? (
        <BackPage
          param={param}
          onClose={() => {
            setParam({})
            setIsVisible(false)
            closeDrawer()
          }}
          open={isVisible}
          reload={() => {
            stateRef.current.minTaskId = ''
            stateRef.current.maxTaskId = ''
            reloadFn()
          }}
        />
      ) : null}
    </div>
  )
}
export default taskList
